import { ComponentProps, ReactNode } from 'react';

import { useShowCauseW_Selector } from '@givebacks/api/core';
import { CauseLogo } from 'core/Components';
import { Card, Group, Stack, Text } from 'ui';

const CauseCardBase = ({
  causeId,
  fullWidth = false,
  ctaButton,
  containerProps,
}: {
  causeId?: string;
  fullWidth?: boolean;
  ctaButton?: ReactNode;
  containerProps?: ComponentProps<typeof Card>;
}) => {
  const { data: cause } = useShowCauseW_Selector({ uuid: causeId });

  return (
    <Card shadow="md" {...containerProps}>
      <Group justify="space-between" dir={fullWidth ? 'column' : 'row'}>
        <Group>
          <CauseLogo cause_uuid={causeId} size="sm" styles={{ borderRadius: 12 }} />
          <Stack gap={4}>
            <Text fw={600} fz={12} c="gray.8">
              {cause?.name}
            </Text>
            <Text fw={400} fz={10} c="gray.8">
              Communication
            </Text>
          </Stack>
        </Group>

        {ctaButton}
      </Group>
    </Card>
  );
};

export { CauseCardBase };
